export const APP_STORE_URL = "https://apps.apple.com/gb/app/theraoffice/id6801333735";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.emergent.practicepro.hxzp26&pcampaignid=web_share";
export const SUPPORT_URL = "https://therasupport.emergent.host/";
export const PRIVACY_URL = "https://docs.google.com/document/d/1olsQCYc9HR9d6LEVTvmVne2afHxXivpKOF4T96lM39E/edit?usp=sharing";
export const TERMS_URL = "https://docs.google.com/document/d/1BuYXTV4pcamawMpbBu6J0FgVo1AjGzaTqg9oF5fEFBA/edit?usp=sharing";
export const EMAIL = "theraofficeeu@gmail.com";
export const INSTAGRAM_URL = "https://www.instagram.com/theraofficeeu";
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61592254096588";

export const translations = {
    el: {
        nav: {
            features: "Χαρακτηριστικά",
            ai: "AI",
            financials: "Οικονομικά",
            pricing: "Τιμές & Συνδρομές",
            presentation: "Παρουσίαση / Λειτουργίες",
            news: "Νέα",
            support: "Υποστήριξη",
            about: "Ο δημιουργός",
            contact: "Επικοινωνία",
            download: "Λήψη",
            cta: "Ξεκινήστε Δωρεάν",
        },
        hero: {
            overline: "Φτιαγμένο από ψυχολόγους, για ψυχολόγους",
            titleA: "Περισσότερη φροντίδα.",
            titleB: "Λιγότερη διαχείριση.",
            sub: "Το TheraOffice είναι η εφαρμογή διαχείρισης ιδιωτικού γραφείου για ψυχολόγους — οργανώνει θεραπευόμενους, συνεδρίες, σημειώσεις και οικονομικά σε ένα καθαρό, ασφαλές και επαγγελματικό περιβάλλον.",
            h1sr: "TheraOffice — Η εφαρμογή διαχείρισης ιδιωτικού γραφείου για ψυχολόγους και επαγγελματίες ψυχικής υγείας",
            ctaPrimary: "Κατέβασμα στο App Store",
            downloadSmall: "Κατέβασμα από το",
            ctaSecondary: "Δήλωσε ενδιαφέρον",
            trialLine: "14 ημέρες δωρεάν δοκιμή · Έπειτα 14,99 € / μήνα",
            available: "Διαθέσιμο τώρα για iOS & Android",
            trial: "14 ημέρες δωρεάν δοκιμή",
            scroll: "Κύλισε για να ανακαλύψεις",
        },
        marquee: [
            "AI Σημειώσεις",
            "Story Mode",
            "Διαχείριση Θεραπευομένων",
            "Έξυπνο Ημερολόγιο",
            "Οικονομικά & Οφειλές",
            "Έρευνες & Ερωτηματολόγια",
            "Βιβλιοθήκη Ασκήσεων",
            "Συμμόρφωση GDPR",
        ],
        chapters: [
            {
                id: "features",
                num: "01",
                label: "Διαχείριση θεραπευομένων",
                title: "Κάθε περίπτωση, απόλυτα οργανωμένη",
                body: "Η ενότητα «Θεραπευόμενοι» συγκεντρώνει τις βασικές πληροφορίες και την πορεία κάθε θεραπευόμενου — χωρίς περιττή πολυπλοκότητα.",
                bullets: [
                    "Προφίλ με φωτογραφία, ονοματεπώνυμο, email, τηλέφωνο, διεύθυνση και επαφή έκτακτης ανάγκης",
                    "Ετικέτες και χρώματα για εύκολη οργάνωση και κατηγοριοποίηση",
                    "Ιστορικό συνεδριών και σημειώσεων συγκεντρωμένο στην κάρτα κάθε θεραπευομένου",
                    "«Θυμηθείτε πριν τη συνεδρία»: το AI διαβάζει τις προηγούμενες σημειώσεις και σου θυμίζει πού είχατε μείνει",
                    "Θεραπευτικό Ταξίδι: συνεδρίες, σημειώσεις και σημαντικά γεγονότα σε μία χρονολογική γραμμή, με εξαγωγή σε PDF",
                ],
                imgs: ["/screenshots/clients-list.webp", "/screenshots/IMG_4762.jpg", "/screenshots/IMG_4761.jpg"],
                alt: "Λίστα θεραπευομένων με αναζήτηση και ετικέτες στο TheraOffice",
            },
            {
                id: "sessions",
                num: "02",
                label: "Συνεδρίες & ημερολόγιο",
                title: "Το πρόγραμμά σου, με μία ματιά",
                body: "Δημιούργησε, ολοκλήρωσε και παρακολούθησε κάθε συνεδρία — δια ζώσης ή διαδικτυακή — από ένα ημερολόγιο σχεδιασμένο για τον ρυθμό του γραφείου σου.",
                bullets: [
                    "Προβολή ημερολογίου ανά ημέρα, εβδομάδα και μήνα",
                    "Διαδικτυακές συνεδρίες με σύνδεσμο συνάντησης",
                    "Ολοκλήρωση με κατάσταση: ολοκληρώθηκε, δεν προσήλθε, ακυρώθηκε ή αναπρογραμματισμός",
                    "Πληρωμή: εξοφλημένη, απλήρωτη, δωρεάν ή μερική με καταχώρηση ποσού",
                    "Υπενθύμιση στον θεραπευόμενο με προσυμπληρωμένο email — και ένδειξη ότι εστάλη",
                ],
                imgs: ["/screenshots/IMG_4766.jpg", "/screenshots/IMG_4737.jpg", "/screenshots/IMG_4741.jpg", "/screenshots/IMG_4745.jpg"],
                alt: "Ημερολόγιο Αυγούστου 2026 με προβολή ημέρας, εβδομάδας και μήνα",
            },
            {
                id: "ai",
                num: "03",
                label: "Τεχνητή νοημοσύνη",
                title: "Ένας βοηθός που διαβάζει τις σημειώσεις σου",
                body: "Το AI του TheraOffice οργανώνει, συνοψίζει και αφηγείται — πάντα με βάση τα δικά σου καταγεγραμμένα δεδομένα, χωρίς ποτέ να επινοεί.",
                bullets: [
                    "Βελτίωση, σύνοψη και επαναδιατύπωση σημειώσεων — με δυνατότητα επιστροφής στο πρωτότυπο",
                    "Story Mode: κλινική αφήγηση, γρήγορο recap ή ασφαλής αφήγηση κατάλληλη για τον θεραπευόμενο",
                    "Mood Graph: γράφημα διάθεσης από τις παρατηρήσεις σου, με κάθε σημείο συνδεδεμένο στη σχετική σημείωση",
                    "Το AI παράγει μόνο από γεγονότα και σημειώσεις που έχεις καταγράψει — χωρίς να επινοεί",
                    "Υποστηρίζει την οργάνωση και τη σύνοψη — δεν αντικαθιστά την κλινική σου κρίση",
                ],
                imgs: ["/screenshots/IMG_4765.jpg", "/screenshots/IMG_4757.jpg", "/screenshots/IMG_4764.jpg"],
                alt: "Story Mode — αφήγηση της θεραπευτικής πορείας από το AI",
            },
            {
                id: "financials",
                num: "04",
                label: "Οικονομικά",
                title: "Έσοδα και οφειλές, χωρίς υπολογιστικά φύλλα",
                body: "Μια ολοκληρωμένη εικόνα της οικονομικής δραστηριότητας του γραφείου σου, ενημερωμένη αυτόματα με κάθε συνεδρία.",
                bullets: [
                    "Έσοδα ανά ημέρα, εβδομάδα, μήνα, έτος και συνολικά — με μέσο όρο αμοιβής συνεδρίας",
                    "Εκκρεμείς οφειλές και απλήρωτες συνεδρίες, αναλυτικά ανά θεραπευόμενο",
                    "Τρόποι πληρωμής: κάρτα, μετρητά, έμβασμα",
                    "Γραφήματα εσόδων τελευταίων 7 ημερών και 6 μηνών, με ιστορικό ανά μήνα",
                    "Ποσοστά ακυρώσεων και απουσιών, και συνολικός αριθμός συνεδριών",
                ],
                imgs: ["/screenshots/IMG_4782.jpeg", "/screenshots/IMG_4783.jpeg"],
                alt: "Οικονομική επισκόπηση με έσοδα, οφειλές και τρόπους πληρωμής",
            },
            {
                id: "library",
                num: "05",
                label: "Βιβλιοθήκη & έρευνες",
                title: "Εργαλεία έτοιμα για τη συνεδρία — και μετά από αυτή",
                body: "Έτοιμες θεραπευτικές ασκήσεις και ερωτηματολόγια με ανάλυση αποτελεσμάτων, όλα μέσα στην εφαρμογή.",
                bullets: [
                    "Έτοιμες ασκήσεις: Ημερολόγιο Σκέψεων, Αναπνοή 4-7-8, Ενεργοποίηση Συμπεριφοράς, Progressive Muscle Relaxation",
                    "Φίλτρα ανά προσέγγιση και πρόβλημα (CBT, άγχος, κατάθλιψη, χαλάρωση) — και δικές σου ασκήσεις με ετικέτες",
                    "Ερωτηματολόγια με πολλαπλή επιλογή, Likert, βαθμολόγηση, ναι/όχι, σύντομο κείμενο και αριθμούς",
                    "Δημοσίευση με μοναδικό σύνδεσμο συμμετοχής και αποτελέσματα σε πραγματικό χρόνο",
                    "AI ανάλυση αποτελεσμάτων: σύνοψη, βασικά ευρήματα, προτάσεις και περιορισμοί",
                ],
                imgs: ["/screenshots/IMG_4774.jpeg", "/screenshots/IMG_4775.jpeg", "/screenshots/IMG_4787.jpeg"],
                alt: "Βιβλιοθήκη ασκήσεων με φίλτρα CBT, άγχος και χαλάρωση",
            },
        ],
        bento: {
            overline: "Και κάτι παραπάνω",
            title: "Ό,τι χρειάζεσαι, σε ένα μέρος",
            more: "Περισσότερα",
            items: [
                {
                    title: "Συρτάρι θεραπευτή",
                    body: "Αρχεία, σημειώσεις, σύνδεσμοι και φωτογραφίες σε έναν προσωπικό χώρο αποθήκευσης.",
                    img: "/screenshots/IMG_4772.jpeg",
                    details: [
                        "Νέος φάκελος, νέα σημείωση ή νέος σύνδεσμος με ένα πάτημα",
                        "Φωτογραφίες από κάμερα ή συλλογή και αρχεία (PDF, doc…)",
                        "Όλα τα υλικά της καθημερινότητάς σου σε έναν κεντρικό χώρο",
                    ],
                },
                {
                    title: "Ψηφιακή κάρτα QR",
                    body: "Η επαγγελματική σου κάρτα, με τα στοιχεία που εσύ επιλέγεις να εμφανίζονται.",
                    img: "/screenshots/IMG_4777.jpeg",
                    details: [
                        "Δημιουργείται αυτόματα από το προφίλ θεραπευτή σου",
                        "Εσύ επιλέγεις τι εμφανίζεται: φωτογραφία, τηλέφωνο, email, διεύθυνση, εκπαίδευση, εμπειρία, social media",
                        "Εναλλακτικά, ανέβασε τη δική σου κάρτα σε PDF ή φωτογραφία",
                        "Όποιος σκανάρει το QR βλέπει μόνο ό,τι έχεις επιλέξει",
                    ],
                },
                {
                    title: "Υπενθυμίσεις",
                    body: "Ενημέρωσε τον θεραπευόμενο για τη συνεδρία με ένα πάτημα.",
                    img: "/screenshots/IMG_4797.jpeg",
                    details: [
                        "Από την κάρτα της συνεδρίας, με ένα πάτημα",
                        "Επιλέγεις την εφαρμογή email σου (Gmail, Outlook, Yahoo)",
                        "Προσυμπληρωμένο μήνυμα με ημερομηνία, ώρα και τρόπο διεξαγωγής",
                        "Εμφανίζεται ένδειξη δίπλα στη συνεδρία μόλις σταλεί",
                    ],
                },
                {
                    title: "Εξαγωγές PDF",
                    body: "Σημειώσεις, θεραπευτικό ταξίδι και αποτελέσματα — εκτυπώσιμα και κοινοποιήσιμα.",
                    img: "/screenshots/IMG_4780.jpeg",
                    details: [
                        "Σημειώσεις, θεραπευτικό ταξίδι, ασκήσεις και αποτελέσματα ερευνών",
                        "Εξαγωγή επιλεγμένων: εσύ ορίζεις τι περιλαμβάνει κάθε αρχείο",
                        "Συμπεριλαμβάνονται αυτόματα τα στοιχεία του προφίλ σου",
                        "Εκτύπωση ή κοινοποίηση απευθείας από την εφαρμογή",
                    ],
                },
                {
                    title: "Mood Graph",
                    body: "Η συναισθηματική πορεία του θεραπευόμενου σε ένα διαδραστικό γράφημα.",
                    img: null,
                    details: [
                        "Το AI εντοπίζει δείκτες διάθεσης μέσα από τις σημειώσεις σου",
                        "Οπτικοποίηση της συναισθηματικής πορείας, συνεδρία προς συνεδρία",
                        "Κάθε σημείο του γραφήματος συνδέεται με το απόσπασμα της σχετικής σημείωσης",
                        "Εξαγωγή σε PDF για αρχειοθέτηση ή εκτύπωση",
                    ],
                },
                {
                    title: "Ασφάλεια & GDPR",
                    body: "Σχεδιασμένο με έμφαση στην προστασία προσωπικών και επαγγελματικών δεδομένων.",
                    img: null,
                    details: [
                        "Συμμόρφωση GDPR και προστασία ευαίσθητων υλικών (φωτογραφίες, έγγραφα)",
                        "Καμία χρήση δεδομένων για διαφημιστική παρακολούθηση",
                        "Οι συνδρομές διαχειρίζονται αποκλειστικά μέσω App Store / Google Play — το TheraOffice δεν αποθηκεύει στοιχεία πληρωμής",
                        "Οριστική διαγραφή λογαριασμού και δεδομένων όποτε το επιθυμείς",
                    ],
                },
            ],
        },
        features: {
            overview: {
                overline: "Λειτουργίες",
                title: "Όλα όσα χρειάζεσαι για το γραφείο σου. Σε ένα μέρος.",
                text: "Το TheraOffice συγκεντρώνει την καθημερινή οργάνωση του ιδιωτικού γραφείου σε ένα καθαρό και εύχρηστο περιβάλλον.",
                benefits: [
                    "Οργάνωση θεραπευόμενων και συνεδριών",
                    "Σημειώσεις και ιστορικό",
                    "Παρακολούθηση οικονομικών",
                    "Θεραπευτικές ασκήσεις",
                    "Έρευνες & ερωτηματολόγια",
                    "Έξυπνες λειτουργίες με AI",
                ],
                cta: "Δείτε όλες τις λειτουργίες",
                cards: [
                    { title: "Θεραπευόμενοι", desc: "Διαχείριση προφίλ και ιστορικού" },
                    { title: "Συνεδρίες & Ημερολόγιο", desc: "Οργάνωση και υπενθυμίσεις" },
                    { title: "Σημειώσεις", desc: "Ασφαλείς και οργανωμένες" },
                    { title: "Οικονομικά", desc: "Πληρωμές, αποδείξεις, αναφορές" },
                    { title: "Ερωτηματολόγια", desc: "Δημιουργία και αξιολόγηση" },
                    { title: "Βιβλιοθήκη", desc: "Χρήσιμο υλικό και πόροι" },
                    { title: "Ψηφιακή Κάρτα", desc: "Προβολή επαγγελματικού προφίλ" },
                    { title: "AI Λειτουργίες", desc: "Έξυπνη υποστήριξη στην καθημερινότητά σας" },
                ],
            },
            aiStrip: {
                overline: "Τεχνολογία που σας στηρίζει",
                title: "AI λειτουργίες για μεγαλύτερη ευκολία",
                text: "Το TheraOffice αξιοποιεί την τεχνητή νοημοσύνη για να σας εξοικονομεί χρόνο και να σας βοηθά να προσφέρετε ακόμη πιο ποιοτική φροντίδα.",
                link: "Μάθετε περισσότερα",
                items: [
                    { title: "Σύνοψη σημειώσεων", desc: "Γρήγορη περίληψη και βασικά σημεία" },
                    { title: "Διανομή ερωτηματολογίων", desc: "Αυτόματη αποστολή στους θεραπευόμενους" },
                    { title: "Ανάλυση αποτελεσμάτων", desc: "Έξυπνη ερμηνεία και προτάσεις" },
                    { title: "Ανακεφαλαίωση προόδου", desc: "Συνοπτική εικόνα της πορείας" },
                    { title: "Γράφημα διάθεσης", desc: "Οπτικοποίηση συναισθημάτων" },
                    { title: "Θεραπευτικό ταξίδι", desc: "Παρακολούθηση στόχων και σταθμών" },
                ],
            },
            howItWorks: "Πώς λειτουργεί",
            catsLabel: "Κατηγορίες σημειώσεων",
            noteCategories: [
                { name: "Παρόν πρόβλημα", desc: "Τι απασχολεί τον θεραπευόμενο αυτή την περίοδο — το ζήτημα που φέρνει στη συνεδρία." },
                { name: "Αίτημα", desc: "Ο στόχος ή το αίτημα με το οποίο ξεκίνησε η θεραπευτική διαδικασία." },
                { name: "Πρόοδος", desc: "Βήματα μπροστά, αλλαγές και ό,τι δείχνει πορεία στη θεραπεία." },
                { name: "Παρέμβαση", desc: "Τεχνικές και παρεμβάσεις που εφαρμόστηκαν στη συνεδρία." },
                { name: "Φαινομενολογική παρατήρηση", desc: "Άμεσες, εμπειρικές παρατηρήσεις όπως προέκυψαν εντός συνεδρίας." },
                { name: "Παρατήρηση", desc: "Γενικές παρατηρήσεις που θέλεις να κρατήσεις για την περίπτωση." },
                { name: "Σχέδιο επόμενης συνεδρίας", desc: "Τι θα δουλέψετε την επόμενη φορά — ο σκεπτικισμός και ο σχεδιασμός σου." },
                { name: "Ιστορικό", desc: "Βιογραφικά και ιστορικά στοιχεία του θεραπευόμενου." },
                { name: "Τραύμα", desc: "Σημειώσεις σχετικές με τραυματικές εμπειρίες, με ιδιαίτερη φροντίδα." },
                { name: "Άλλο", desc: "Οτιδήποτε άλλο δεν ταιριάζει σε κατηγορία — ή δική σου ενότητα με «+ Ενότητα»." },
            ],
            list: [
                {
                    num: "01",
                    title: "Αρχική Οθόνη",
                    short: "Η αρχική οθόνη λειτουργεί ως το κεντρικό σημείο οργάνωσης του γραφείου και προσφέρει άμεση πρόσβαση στις βασικές λειτουργίες της εφαρμογής.",
                    details: [
                        "Γρήγορες ενέργειες: δημιούργησε άμεσα νέα σημείωση, θεραπευόμενο ή συνεδρία",
                        "Δημόσια επαγγελματική κάρτα: πρόβαλε τα στοιχεία σου μέσω QR",
                        "Οικονομικά: πληρωμές, οφειλές και βασική οικονομική εικόνα",
                        "Έρευνες: πρόσβαση σε ερωτηματολόγια και αποτελέσματα",
                        "Σημερινές συνεδρίες: το πρόγραμμα της ημέρας με μία ματιά",
                        "Συνοπτική δραστηριότητα: συνεδρίες ημέρας και εβδομάδας",
                        "Κεντρική πλοήγηση: θεραπευόμενοι, ημερολόγιο, συρτάρι και βιβλιοθήκη",
                    ],
                    imgs: ["/guide/48.webp"],
                    alt: "Η αρχική οθόνη του TheraOffice με γρήγορες ενέργειες, οικονομικά και σημερινές συνεδρίες",
                },
                {
                    num: "02",
                    title: "Διαχείριση Θεραπευόμενων",
                    short: "Οργάνωσε τα βασικά στοιχεία, τα tags, τις σημειώσεις και την πορεία κάθε θεραπευόμενου.",
                    details: [
                        "Πήγαινε στην ενότητα «Θεραπευόμενοι» και επίλεξε «Νέος Θεραπευόμενος»",
                        "Συμπλήρωσε τα βασικά στοιχεία: ονοματεπώνυμο, email, τηλέφωνο, διεύθυνση, επείγουσα επαφή, προτιμώμενη γλώσσα",
                        "Πρόσθεσε ετικέτες (π.χ. «Άγχος») με «+ Νέο tag» και χρώμα για ευκολότερη κατηγοριοποίηση",
                        "Επίλεξε φωτογραφία προφίλ, εφόσον το επιθυμείς",
                        "Πάτησε «Αποθήκευση» — το νέο προφίλ δημιουργείται με οργανωμένες πληροφορίες, σημειώσεις και ιστορικό συνεδριών",
                    ],
                    imgs: ["/guide/47.webp", "/guide/46.webp"],
                    alt: "Προσθήκη νέου θεραπευόμενου με στοιχεία και ετικέτες",
                },
                {
                    num: "03",
                    title: "Προσθήκη Συνεδρίας",
                    short: "Προγραμμάτισε εύκολα μια νέα συνεδρία και πρόσθεσέ την στο ημερολόγιο.",
                    details: [
                        "Πάτησε «Νέα Συνεδρία» από την αρχική οθόνη ή μέσα από το Ημερολόγιο",
                        "Επίλεξε τον θεραπευόμενο από την αναπτυσσόμενη λίστα και τον τίτλο της συνεδρίας",
                        "Όρισε ημερομηνία και ώρα — με τους παρεχόμενους χρόνους ή πληκτρολογώντας τη δική σου",
                        "Επίλεξε διάρκεια: 30, 45, 50, 60 λεπτά ή προσαρμοσμένη",
                        "Για διαδικτυακή συνεδρία ενεργοποίησε την αντίστοιχη επιλογή και πρόσθεσε τον σύνδεσμο της online συνάντησης",
                        "Προαιρετικά, πρόσθεσε tags συνεδρίας για ευκολότερη οργάνωση",
                        "Πάτησε «Αποθήκευση» και η συνεδρία προστίθεται στο πρόγραμμά σου",
                    ],
                    imgs: ["/guide/45.webp", "/guide/44.webp"],
                    alt: "Δημιουργία νέας συνεδρίας με ημερομηνία, ώρα και διάρκεια",
                },
                {
                    num: "04",
                    title: "Η συνεδρία σου σε πραγματικό χρόνο",
                    short: "Δες το επόμενο ραντεβού σου και παρακολούθησε τη συνεδρία καθώς εξελίσσεται.",
                    details: [
                        "Η επόμενη συνεδρία εμφανίζεται στην αρχική οθόνη με την ώρα έναρξης και τον χρόνο που απομένει",
                        "Πριν τη συνεδρία, διαθέσιμη η επιλογή «Θυμηθείτε πριν τη συνεδρία» για να ετοιμαστείς",
                        "Μόλις ξεκινήσει, η κάρτα της συνεδρίας αλλάζει σε «Σε εξέλιξη»",
                        "Εμφανίζεται χρονόμετρο με τον χρόνο που έχει περάσει και τον χρόνο που απομένει",
                        "Πάτησε «Σημείωση» για άμεση καταγραφή ό,τι χρειάζεσαι κατά τη διάρκεια της συνεδρίας",
                    ],
                    imgs: ["/guide/43.webp", "/guide/41.webp"],
                    alt: "Κάρτα επόμενης συνεδρίας με αντίστροφη μέτρηση και λειτουργία σε εξέλιξη",
                },
                {
                    num: "05",
                    title: "Ολοκλήρωση Συνεδρίας",
                    short: "Κατέγραψε τι συνέβη στη συνεδρία και ενημέρωσε την κατάστασή της.",
                    details: [
                        "Άνοιξε τη συνεδρία και επίλεξε «Ολοκλήρωση Συνεδρίας»",
                        "Κατάσταση: ολοκληρώθηκε, ο θεραπευόμενος δεν προσήλθε, ακυρώθηκε ή αναπρογραμματισμός με νέα ημερομηνία και ώρα",
                        "Τύπος συνεδρίας: δια ζώσης ή διαδικτυακά",
                        "Πληρωμή: πληρώθηκε, απλήρωτη, δωρεάν ή μερική — στη μερική ανοίγει πεδίο για το ποσό που πληρώθηκε",
                        "Καταχώρησε πληρωμένο και αναμενόμενο ποσό (€) και πρόσθεσε σημειώσεις",
                        "Μετάβαση απευθείας σε Σημειώσεις, Καρτέλα θεραπευόμενου ή υπενθύμιση — και «Αποθήκευση»",
                    ],
                    imgs: ["/guide/40.webp", "/guide/39.webp"],
                    alt: "Οθόνη ολοκλήρωσης συνεδρίας με κατάσταση, πληρωμή και σημειώσεις",
                },
                {
                    num: "06",
                    title: "Αποστολή Υπενθύμισης",
                    short: "Στείλε εύκολα ενημέρωση στον θεραπευόμενο πριν από τη συνεδρία.",
                    details: [
                        "Άνοιξε την καρτέλα της συνεδρίας και επίλεξε «Υπενθύμιση»",
                        "Διάλεξε την εφαρμογή email που προτιμάς: Gmail, Outlook, Yahoo Mail ή την προεπιλεγμένη",
                        "Θα ανοίξει αυτόματα ένα έτοιμο email με τα στοιχεία σου ως θεραπευτή",
                        "Το μήνυμα περιλαμβάνει ήδη ημερομηνία, ώρα και τρόπο διεξαγωγής της συνεδρίας",
                        "Το μόνο που χρειάζεται είναι να πατήσεις «Αποστολή»",
                        "Στο Ημερολόγιο εμφανίζεται μικρό σύμβολο δίπλα στη συνεδρία, ότι η υπενθύμιση έχει σταλεί",
                    ],
                    imgs: ["/guide/4.webp", "/guide/2.webp", "/guide/1.webp", "/guide/3.webp"],
                    alt: "Αποστολή υπενθύμισης συνεδρίας με έτοιμο email",
                },
                {
                    num: "07",
                    title: "Οικονομικά",
                    short: "Δες συγκεντρωμένα την οικονομική εικόνα του γραφείου σου.",
                    details: [
                        "Έσοδα της ημέρας, της εβδομάδας, του μήνα και συνολικά",
                        "Συνολικές οφειλές, αναλυτικά ανά θεραπευόμενο και συνεδρία με υπόλοιπο",
                        "Απλήρωτες συνεδρίες και εκκρεμείς πληρωμές",
                        "Τρόποι πληρωμής: κάρτα, μετρητά, έμβασμα",
                        "Σύνολο συνεδριών και ποσοστά ακυρώσεων και απουσιών",
                        "Γραφήματα εσόδων: τελευταίες 7 μέρες, τελευταίοι 6 μήνες και ιστορικό ανά μήνα",
                    ],
                    imgs: ["/guide/17.webp", "/guide/18.webp", "/guide/16.webp"],
                    alt: "Οικονομική επισκόπηση με έσοδα, οφειλές και γραφήματα",
                },
                {
                    num: "08",
                    title: "Οργανωμένες Σημειώσεις",
                    short: "Κατέγραψε και οργάνωσε πληροφορίες για κάθε θεραπευόμενο με καθαρή κατηγοριοποίηση.",
                    details: [
                        "Νέα σημείωση από την Αρχική Οθόνη ή μέσα από την Καρτέλα Θεραπευόμενου",
                        "Επίλεξε θεραπευόμενο — η ημερομηνία συνεδρίας είναι προεπιλεγμένη και αλλάζει με τα βελάκια",
                        "Κατηγοριοποίηση με ενότητες: Παρόν πρόβλημα, Αίτημα, Πρόοδος, Παρέμβαση, Παρατήρηση, Ιστορικό, Σχέδιο επόμενης συνεδρίας, Άλλο",
                        "Δημιούργησε δικές σου κατηγορίες με «+ Ενότητα»",
                        "Πρόσθεσε κείμενο, φωτογραφίες, εικόνες ή φωνητική καταγραφή και πάτησε «Αποθήκευση»",
                    ],
                    imgs: ["/guide/37.webp"],
                    alt: "Δημιουργία σημείωσης με κατηγορίες περιεχομένου",
                },
                {
                    num: "09",
                    title: "AI Βοήθεια στις Σημειώσεις",
                    short: "Χρησιμοποίησε AI για να οργανώσεις καλύτερα το κείμενό σου.",
                    details: [
                        "Στις σημειώσεις προσθέτεις κείμενο, φωτογραφίες, εικόνες ή φωνητική καταγραφή",
                        "Αφού γράψεις, επίλεξε «AI Βοήθεια» κάτω από το πεδίο κειμένου",
                        "Βελτίωση: πιο καθαρή και οργανωμένη διατύπωση",
                        "Σύνοψη: τα βασικά σημεία μιας μεγαλύτερης σημείωσης",
                        "Επαναδιατύπωση: το ίδιο περιεχόμενο με διαφορετικό, πιο δομημένο τρόπο",
                        "Μπορείς να δεις ή να επιστρέψεις στο πρωτότυπο κείμενο όποτε θέλεις",
                        "Οι σημειώσεις εξάγονται σε PDF ή εκτυπώνονται",
                    ],
                    imgs: ["/guide/36.webp", "/guide/34.webp"],
                    alt: "AI βοήθεια σε σημείωση με βελτίωση και σύνοψη κειμένου",
                },
                {
                    num: "10",
                    title: "Θυμηθείτε πριν τη συνεδρία",
                    short: "Μια σύντομη AI υπενθύμιση με όσα αξίζει να έχεις κατά νου πριν από την επόμενη συνεδρία.",
                    details: [
                        "Διαθέσιμο από την κάρτα της επόμενης συνεδρίας στην αρχική οθόνη",
                        "Και από την καρτέλα του θεραπευόμενου, στην «Επισκόπηση» ή το «Θεραπευτικό Ταξίδι»",
                        "Το AI διαβάζει τις προηγούμενες σημειώσεις και εντοπίζει τα πιο σημαντικά σημεία της διαδικασίας",
                        "Δημιουργεί σύντομη υπενθύμιση με βασικά θέματα και πρόσφατες εξελίξεις",
                        "Περιλαμβάνει «AI – Βασικά σημεία» και «Ορόσημα» της θεραπείας — θυμάσαι πού είχατε μείνει",
                    ],
                    imgs: ["/guide/33.webp", "/guide/8.webp", "/guide/6.webp"],
                    alt: "AI υπενθύμιση πριν τη συνεδρία με βασικά σημεία",
                },
                {
                    num: "11",
                    title: "Θεραπευτικό Ταξίδι",
                    short: "Δες την πορεία κάθε θεραπευόμενου σε ένα οργανωμένο χρονολογικό timeline.",
                    details: [
                        "Το AI διαβάζει τις σημειώσεις και βοηθά στην αναγνώριση σημαντικών γεγονότων",
                        "Εσύ επιλέγεις ποια γεγονότα κρατάς, ώστε το timeline να μένει οργανωμένο",
                        "Περιλαμβάνει συνεδρίες, σημειώσεις, θεραπευτικές εργασίες και σημαντικά γεγονότα, ταξινομημένα χρονικά",
                        "Κατηγοριοποίησε με tags (π.χ. #εργασία, #όρια, #φόβος απόρριψης)",
                        "Το Θεραπευτικό Ταξίδι εξάγεται σε PDF ή εκτυπώνεται",
                    ],
                    imgs: ["/guide/33.webp", "/guide/32.webp"],
                    alt: "Χρονολογικό timeline θεραπευτικού ταξιδιού θεραπευόμενου",
                },
                {
                    num: "12",
                    title: "Story Mode",
                    short: "Μετέτρεψε την πορεία του θεραπευόμενου σε μια φυσική και συνεχόμενη αφήγηση.",
                    details: [
                        "Κλινική Αφήγηση: πιο αναλυτική και επαγγελματική παρουσίαση",
                        "Γρήγορο Recap: σύντομη αποτύπωση των βασικών σημείων",
                        "Ασφαλής Αφήγηση: προσεκτικά διατυπωμένο κείμενο, κατάλληλο για παρουσίαση στον θεραπευόμενο",
                        "Το AI οργανώνει χρονολογικά τα ήδη καταγεγραμμένα γεγονότα και σημειώσεις σε πιο αναγνώσιμη αφήγηση",
                        "Μπορείς να αποθηκεύσεις την παραγόμενη αφήγηση",
                    ],
                    imgs: ["/guide/31.webp", "/guide/30.webp"],
                    alt: "Story Mode με τρεις τρόπους αφήγησης της θεραπευτικής πορείας",
                },
                {
                    num: "13",
                    title: "Mood Graph",
                    short: "Παρακολούθησε οπτικά τη συναισθηματική πορεία του θεραπευόμενου μέσα στον χρόνο.",
                    details: [
                        "Από την καρτέλα του θεραπευόμενου επίλεξε «Γράφημα διάθεσης»",
                        "Το AI εντοπίζει βασικές ενδείξεις διάθεσης από τις σημειώσεις και τις αποτυπώνει σε γράφημα",
                        "Κάθε σημείο αντιστοιχεί σε καταγεγραμμένη παρατήρηση — πάτησέ το για να δεις το απόσπασμα της σημείωσης",
                        "Στο κάτω μέρος υπάρχει περίληψη της πορείας και υπόμνημα ενδείξεων (coping, anxious, distressed)",
                        "Το γράφημα εξάγεται σε PDF για αποθήκευση ή εκτύπωση",
                    ],
                    imgs: ["/guide/50.webp"],
                    alt: "Γράφημα διάθεσης θεραπευόμενου μέσα στον χρόνο",
                },
                {
                    num: "14",
                    title: "Συρτάρι Θεραπευτή",
                    short: "Ένας προσωπικός χώρος αποθήκευσης επαγγελματικού υλικού μέσα στην εφαρμογή.",
                    details: [
                        "Οργάνωσε αρχεία, έγγραφα, φωτογραφίες, συνδέσμους και σημειώσεις σε ένα σημείο",
                        "Πάτησε «+» για νέο φάκελο, νέα σημείωση ή νέο σύνδεσμο",
                        "Φωτογραφία απευθείας από την κάμερα ή εικόνα από τη συλλογή σου",
                        "Αρχεία κάθε τύπου (PDF, doc…)",
                        "Όλα τα υλικά της καθημερινής σου πρακτικής, πάντα διαθέσιμα",
                    ],
                    imgs: ["/guide/28.webp", "/guide/29.webp"],
                    alt: "Συρτάρι θεραπευτή με φακέλους και επιλογές προσθήκης υλικού",
                },
                {
                    num: "15",
                    title: "Βιβλιοθήκη Θεραπευτικών Ασκήσεων",
                    short: "Χρησιμοποίησε έτοιμες ασκήσεις ή δημιούργησε και οργάνωσε τις δικές σου.",
                    details: [
                        "Έτοιμες θεραπευτικές ασκήσεις για άμεση χρήση",
                        "Πρόσθεσε δικές σου με «+»: τίτλος, περιγραφή, τεχνική, διάρκεια, επίπεδο δυσκολίας",
                        "Οργάνωση και κατηγοριοποίηση με tags — ανά είδος, θεραπευτική προσέγγιση ή πρόβλημα",
                        "Αναζήτηση και φίλτρα: Όλα, CBT, Άγχος, Κατάθλιψη, Χαλάρωση",
                        "Κάθε άσκηση εκτυπώνεται ή αποστέλλεται στον θεραπευόμενο",
                    ],
                    imgs: ["/guide/27.webp"],
                    alt: "Βιβλιοθήκη ασκήσεων με φίλτρα και αναζήτηση",
                },
                {
                    num: "16",
                    title: "Προφίλ Θεραπευτή",
                    short: "Οργάνωσε τα επαγγελματικά στοιχεία που θέλεις να εμφανίζονται μέσα από το TheraOffice.",
                    details: [
                        "Πήγαινε στις Ρυθμίσεις και επίλεξε «Προφίλ Θεραπευτή»",
                        "Φωτογραφία προφίλ, λογότυπο, ονοματεπώνυμο, επαγγελματικός τίτλος και άδεια εξάσκησης",
                        "Εμπειρία σε έτη, πτυχία, πιστοποιήσεις, ειδικεύσεις και γλώσσες",
                        "Στοιχεία επικοινωνίας και διευθύνσεις",
                        "Εσύ επιλέγεις ποια από αυτά εμφανίζονται",
                        "Προβάλλονται αυτόματα στα αρχεία που εξάγεις ή εκτυπώνεις και στην ψηφιακή επαγγελματική σου κάρτα",
                    ],
                    imgs: ["/guide/23.webp", "/guide/25.webp"],
                    alt: "Φόρμα προφίλ θεραπευτή με πτυχία και στοιχεία",
                },
                {
                    num: "17",
                    title: "Ψηφιακή Επαγγελματική Κάρτα QR",
                    short: "Δημιούργησε και μοιράσου εύκολα την επαγγελματική σου κάρτα μέσω QR.",
                    details: [
                        "Η QR κάρτα δημιουργείται αυτόματα από τα στοιχεία του Προφίλ Θεραπευτή",
                        "Πρόσβαση από την αρχική οθόνη, μέσω «Δημόσια επαγγελματική κάρτα»",
                        "Εναλλακτικά, ανέβασε τη δική σου επαγγελματική κάρτα σε PDF ή φωτογραφία",
                        "Επίλεξε ποια κάρτα εμφανίζεται και ποια πεδία περιλαμβάνει (φωτογραφία, τηλέφωνο, email, εκπαίδευση, εμπειρία, social media)",
                        "Αντίγραψε τον σύνδεσμο ή κοινοποίησε το QR σε όποιον θέλεις",
                    ],
                    imgs: ["/guide/21.webp", "/guide/22.webp", "/guide/19.webp", "/guide/20.webp"],
                    alt: "Ψηφιακή επαγγελματική κάρτα με QR κώδικα",
                },
                {
                    num: "18",
                    title: "Έρευνες & Ερωτηματολόγια",
                    short: "Δημιούργησε και διαχειρίσου έρευνες μέσα από την εφαρμογή.",
                    details: [
                        "Νέα έρευνα με τίτλο, περιγραφή, σκοπό και στοιχεία επικοινωνίας",
                        "Κείμενο συγκατάθεσης και περίοδος διατήρησης δεδομένων",
                        "Τύποι ερωτήσεων: πολλαπλή επιλογή, dropdown, κλίμακα Likert, αριθμητική βαθμολογία, Ναι/Όχι, σύντομο κείμενο, ανοιχτή απάντηση, αριθμός",
                        "Συμμετοχή ανώνυμη, με ψευδώνυμο ή επώνυμη — πολλαπλές υποβολές, μέγιστος αριθμός απαντήσεων, ημερομηνίες ανοίγματος και κλεισίματος",
                        "Με τη «Δημοσίευση» δημιουργείται μοναδικό link που στέλνεις στους συμμετέχοντες",
                    ],
                    imgs: ["/guide/15.webp", "/guide/14.webp", "/guide/13.webp"],
                    alt: "Δημιουργία έρευνας με τύπους ερωτήσεων και ρυθμίσεις συμμετοχής",
                },
                {
                    num: "19",
                    title: "Ζωντανά Αποτελέσματα & AI Ανάλυση",
                    short: "Παρακολούθησε τις απαντήσεις καθώς έρχονται και δες αυτόματα στατιστικά και AI συμπεράσματα.",
                    details: [
                        "Κάθε νέα απάντηση εμφανίζεται άμεσα, ζωντανά από το κινητό σου",
                        "Αυτόματα γραφήματα, ποσοστά και στατιστικά για κάθε ερώτηση",
                        "Η AI Ανάλυση χρησιμοποιεί τα ήδη υπολογισμένα στατιστικά",
                        "Παράγει σύνοψη, βασικά ευρήματα, προτάσεις και περιορισμούς (π.χ. λόγω μικρού δείγματος)",
                        "Εξαγωγή των αποτελεσμάτων σε PDF",
                    ],
                    imgs: ["/guide/9.webp", "/guide/10.webp", "/guide/11.webp", "/guide/12.webp"],
                    alt: "Ζωντανά αποτελέσματα έρευνας με γραφήματα και AI ανάλυση",
                },
                {
                    num: "20",
                    title: "Ρυθμίσεις & Βοήθεια",
                    short: "Πρόσβαση σε επιπλέον εργαλεία διαχείρισης και υποστήριξης.",
                    details: [
                        "Εξαγωγή επιλεγμένων: εσύ επιλέγεις ακριβώς ποια στοιχεία εμφανίζονται στο αρχείο που εξάγεις ή εκτυπώνεις",
                        "Βοήθεια & Οδηγίες για τη χρήση της εφαρμογής",
                        "AI Υποστήριξη για απορίες σχετικά με λειτουργίες του TheraOffice",
                        "Σχόλια & Προτάσεις: στείλε feedback και ιδέες για τη βελτίωση της εφαρμογής",
                        "Συμμόρφωση GDPR, χωρίς διαφημιστικό tracking, με δυνατότητα οριστικής διαγραφής λογαριασμού",
                    ],
                    imgs: ["/guide/7.webp"],
                    alt: "Ρυθμίσεις εφαρμογής με βοήθεια και εξαγωγή επιλεγμένων",
                },
            ],
        },
        pricing: {
            overline: "Τιμές & Συνδρομές",
            title: "14 ημέρες δωρεάν δοκιμή",
            bandOverline: "Ξεκινήστε σήμερα",
            bandText: "Ανακαλύψτε πώς το TheraOffice μπορεί να κάνει τη διαφορά στην καθημερινότητά σας.",
            checks: ["Πλήρης πρόσβαση σε όλες τις λειτουργίες", "Χωρίς δέσμευση", "Ακύρωση οποιαδήποτε στιγμή"],
            thenLabel: "Έπειτα",
            cta: "Ξεκινήστε Δωρεάν",
            price: "14,99 €",
            perMonth: "τον μήνα",
            trialBadge: "14 ημέρες δωρεάν δοκιμή",
            cardNote: "Χωρίς επίπεδα και κρυφές χρεώσεις — πρόσβαση σε όλες τις λειτουργίες του TheraOffice.",
            points: [
                "Προς το παρόν, το TheraOffice προσφέρει ένα μόνο, απλό πακέτο συνδρομής, χωρίς διαφορετικά επίπεδα ή περίπλοκες επιλογές.",
                "Η συνδρομή ξεκινά με 14 ημέρες δωρεάν δοκιμή, ώστε να μπορείς να γνωρίσεις την εφαρμογή και να δοκιμάσεις τις λειτουργίες της στην πράξη πριν αποφασίσεις αν θέλεις να συνεχίσεις. Κατά τη διάρκεια της δοκιμαστικής περιόδου μπορείς να χρησιμοποιήσεις το TheraOffice για την οργάνωση θεραπευόμενων, συνεδριών, σημειώσεων, οικονομικών, θεραπευτικών ασκήσεων, ερευνών και των διαθέσιμων έξυπνων λειτουργιών της εφαρμογής.",
                "Μετά το τέλος των 14 ημερών, η συνδρομή κοστίζει 14,99 € τον μήνα.",
                "Αν μέσα στη δωρεάν δοκιμαστική περίοδο αποφασίσεις ότι δεν θέλεις να συνεχίσεις, μπορείς να ακυρώσεις τη συνδρομή σου οποιαδήποτε στιγμή πριν ολοκληρωθούν οι 14 ημέρες, χωρίς να υπάρξει χρέωση για τον επόμενο μήνα. Η διαχείριση και η ακύρωση της συνδρομής πραγματοποιούνται μέσω του λογαριασμού σου στο App Store ή στο Google Play, ανάλογα με τη συσκευή που χρησιμοποιείς.",
                "Οι πληρωμές πραγματοποιούνται αποκλειστικά μέσω των επίσημων και ασφαλών συστημάτων πληρωμών της Apple και της Google. Το TheraOffice δεν αποθηκεύει, δεν επεξεργάζεται και δεν έχει πρόσβαση στα στοιχεία της πιστωτικής ή χρεωστικής κάρτας σου.",
                "Η συνδρομή ανανεώνεται αυτόματα κάθε μήνα, εκτός αν την ακυρώσεις από τις ρυθμίσεις της Apple ή της Google πριν από την επόμενη ημερομηνία ανανέωσης.",
                "Η φιλοσοφία της τιμολόγησης είναι να παραμένει όσο γίνεται πιο απλή και ξεκάθαρη: μία συνδρομή, μία τιμή και πρόσβαση στις λειτουργίες του TheraOffice, χωρίς να χρειάζεται να επιλέξεις ανάμεσα σε διαφορετικά πακέτα.",
            ],
        },
        support: {
            overline: "Υποστήριξη",
            title: "Πώς μπορούμε να βοηθήσουμε;",
            sub: "Αντιμετωπίζεις κάποιο πρόβλημα με την εφαρμογή ή θέλεις να διαγράψεις τον λογαριασμό σου; Επίλεξε τη φόρμα που σε αφορά.",
            problem: {
                title: "Αναφορά προβλήματος",
                desc: "Περίγραψέ μας το πρόβλημα ή την απορία σου και η ομάδα μας θα επικοινωνήσει μαζί σου το συντομότερο.",
                subject: "Θέμα",
                subjects: ["Τεχνικό πρόβλημα", "Λογαριασμός & συνδρομή", "Πρόταση βελτίωσης", "Κάτι άλλο"],
                message: "Περιγραφή προβλήματος",
                submit: "Αποστολή αιτήματος",
                success: "Το αίτημα υποστήριξης εστάλη — θα επικοινωνήσουμε σύντομα.",
            },
            deletion: {
                title: "Διαγραφή λογαριασμού TheraOffice",
                intro: "Με την υποβολή αυτού του αιτήματος θα διαγραφεί ο λογαριασμός σου στο TheraOffice και τα συσχετιζόμενα προσωπικά δεδομένα, εκτός από δεδομένα που ενδέχεται να πρέπει να διατηρήσουμε όπου απαιτείται από τον νόμο. Η ομάδα μας εξετάζει κάθε αίτημα προσωπικά και θα επιβεβαιώσει την ολοκλήρωση μέσω email.",
                name: "Ονοματεπώνυμο",
                email: "Email λογαριασμού",
                reason: "Λόγος (προαιρετικό)",
                confirm: "Κατανοώ ότι αυτό το αίτημα αφορά τη διαγραφή του λογαριασμού μου στο TheraOffice.",
                submit: "Υποβολή αιτήματος διαγραφής",
                success: "Το αίτημα διαγραφής καταχωρήθηκε — θα λάβεις επιβεβαίωση με email μόλις ολοκληρωθεί.",
            },
        },
        showcase: {
            metaTitle: "Λειτουργίες TheraOffice | Εφαρμογή Διαχείρισης για Ψυχολόγους",
            metaDesc: "Δες αναλυτικά τις λειτουργίες του TheraOffice για διαχείριση θεραπευόμενων, συνεδριών, σημειώσεων, οικονομικών, θεραπευτικών ασκήσεων, ερευνών και AI εργαλείων.",
            overline: "Διαδραστικός οδηγός",
            title: "Παρουσίαση / Λειτουργίες εφαρμογής",
            subtitle: "Ανακάλυψε αναλυτικά πώς το TheraOffice οργανώνει την καθημερινή λειτουργία ενός επαγγελματία ψυχικής υγείας — από τις συνεδρίες και τις σημειώσεις μέχρι την πορεία του θεραπευόμενου, τα οικονομικά, τις ασκήσεις, τις έρευνες και τα εργαλεία AI.",
            discoveryTitle: "Τι θέλεις να οργανώσεις καλύτερα;",
            allLabel: "Όλα",
            resultsLabel: "Αποτελέσματα",
            topics: [
                { id: "sessions", label: "Συνεδρίες", nums: ["03", "04", "05", "06"] },
                { id: "clients", label: "Θεραπευόμενους", nums: ["02", "08", "11", "12", "13"] },
                { id: "notes", label: "Σημειώσεις", nums: ["08", "09", "10"] },
                { id: "finance", label: "Οικονομικά", nums: ["07"] },
                { id: "exercises", label: "Θεραπευτικές Ασκήσεις", nums: ["15"] },
                { id: "surveys", label: "Έρευνες", nums: ["18", "19"] },
                { id: "ai", label: "AI", nums: ["09", "10", "11", "12", "13", "19"] },
            ],
            categories: [
                { id: "org", label: "Οργάνωση", title: "Καθημερινή Οργάνωση", nums: ["01", "03", "04", "05", "06", "07"] },
                { id: "clients", label: "Θεραπευόμενοι", title: "Θεραπευόμενοι & Κλινική Πορεία", nums: ["02", "08", "10", "11", "12", "13"] },
                { id: "ai", label: "AI", title: "AI Εργαλεία", nums: ["09", "10", "11", "12", "13", "19"] },
                { id: "tools", label: "Εργαλεία", title: "Εργαλεία Θεραπευτή", nums: ["14", "15"] },
                { id: "profile", label: "Επαγγελματικό Προφίλ", title: "Επαγγελματική Παρουσία", nums: ["16", "17"] },
                { id: "surveys", label: "Έρευνες", title: "Έρευνες & Αξιολόγηση", nums: ["18", "19"] },
                { id: "settings", label: "Ρυθμίσεις", title: "Ρυθμίσεις & Υποστήριξη", nums: ["20"] },
            ],
            ctaTitle: "Δες πώς μπορεί το TheraOffice να οργανώσει τη δική σου καθημερινότητα.",
            ctaText: "Δοκίμασε όλες τις λειτουργίες και δες ποιες ταιριάζουν περισσότερο στις ανάγκες του γραφείου σου.",
            ctaPrimary: "14 ημέρες δωρεάν δοκιμή",
            ctaSecondary: "Επικοινωνία",
        },
        news: {
            metaTitle: "Νέα & Άρθρα | TheraOffice",
            metaDesc: "Νέα, άρθρα και ενημερώσεις από το TheraOffice — η εφαρμογή διαχείρισης ιδιωτικού γραφείου για ψυχολόγους.",
            overline: "Blog / Ενημερώσεις",
            title: "Νέα",
            subtitle: "Νέα, άρθρα και ενημερώσεις από το TheraOffice.",
            filters: { all: "Όλα", article: "Άρθρα", news: "Νέα TheraOffice", instagram: "Social", guide: "Οδηγοί" },
            readMore: "Διαβάστε περισσότερα",
            viewInstagram: "Δείτε τη δημοσίευση στο Instagram",
            viewOriginal: "Δείτε τη δημοσίευση στο",
            share: "Κοινοποίηση",
            copyLink: "Αντιγραφή συνδέσμου",
            copied: "Ο σύνδεσμος αντιγράφηκε",
            related: "Σχετικά άρθρα",
            back: "Όλα τα νέα",
            latestTitle: "Τελευταία Νέα",
            latestCta: "Δείτε όλα τα νέα",
            empty: "Δεν υπάρχουν ακόμη δημοσιεύσεις σε αυτή την κατηγορία.",
            loading: "Φόρτωση…",
        },
        availability: {
            overline: "Λήψη εφαρμογής",
            title: "Κατεβάστε το TheraOffice",
            sub: "Διαθέσιμο τώρα για iOS και Android. Ξεκινήστε με 14 ημέρες δωρεάν δοκιμή — χωρίς δέσμευση, ακύρωση οποιαδήποτε στιγμή.",
            ios: "Λήψη στο App Store",
            androidBadge: "Λήψη στο Google Play",
            note: "Η συνδρομή διαχειρίζεται με ασφάλεια μέσω App Store ή Google Play · Δεν αποθηκεύονται στοιχεία πληρωμής",
            guide: "Κατέβασε τον οδηγό χρήσης (PDF)",
        },
        founder: {
            overline: "Σχετικά με εμάς",
            title: "Από το γραφείο, για το γραφείο",
            quote: "Ήθελα ένα εργαλείο φτιαγμένο πραγματικά για τον τρόπο που δουλεύουμε — λιγότερος χρόνος στη διαχείριση, περισσότερος στη θεραπευτική διαδικασία.",
            name: "Άγγελος Δαλδογιάννης",
            posterAlt: "Άγγελος Δαλδογιάννης, ψυχολόγος και δημιουργός του TheraOffice — Φτιαγμένο από ψυχολόγο, για ψυχολόγους",
            role: "Ψυχολόγος · Δημιουργός του TheraOffice",
            body: "Απόφοιτος του τμήματος Ψυχολογίας του Πανεπιστημίου Δυτικής Μακεδονίας, με συνεχή εκπαίδευση στην προσέγγιση Gestalt. Η ιδέα για το TheraOffice γεννήθηκε από την καθημερινή εμπειρία στον χώρο της ψυχολογίας — και εξελίσσεται μαζί με τις πραγματικές ανάγκες των επαγγελματιών που το χρησιμοποιούν.",
        },
        contact: {
            overline: "Επικοινωνία",
            title: "Ας μιλήσουμε για το γραφείο σου",
            sub: "Δήλωσε ενδιαφέρον, ζήτα μια παρουσίαση ή ρώτησέ μας ό,τι χρειάζεσαι για το γραφείο σου.",
            name: "Ονοματεπώνυμο",
            email: "Email",
            role: "Ιδιότητα (π.χ. Ψυχολόγος)",
            message: "Μήνυμα",
            submit: "Αποστολή μηνύματος",
            sending: "Αποστολή…",
            success: "Το μήνυμα εστάλη — θα επικοινωνήσουμε σύντομα.",
            error: "Κάτι πήγε στραβά. Δοκίμασε ξανά ή γράψε μας στο theraofficeeu@gmail.com.",
            direct: "Ή επικοινώνησε απευθείας",
            support: "Κέντρο υποστήριξης",
        },
        footer: {
            tagline: "Περισσότερη φροντίδα. Λιγότερη διαχείριση.",
            made: "Φτιαγμένο από ψυχολόγους, για ψυχολόγους.",
            rights: "© 2026 TheraOffice. Με εκτίμηση από την ομάδα μας.",
            links: { appstore: "App Store", googleplay: "Google Play", support: "Υποστήριξη", instagram: "Instagram", facebook: "Facebook", email: "Email", privacy: "Πολιτική Απορρήτου", terms: "Όροι & Προϋποθέσεις" },
        },
    },
    en: {
        nav: {
            features: "Features",
            ai: "AI",
            financials: "Financials",
            pricing: "Pricing",
            presentation: "Presentation / Features",
            news: "News",
            support: "Support",
            about: "Founder",
            contact: "Contact",
            download: "Download",
            cta: "Start Free",
        },
        hero: {
            overline: "Made by psychologists, for psychologists",
            titleA: "More care.",
            titleB: "Less management.",
            sub: "TheraOffice is the practice management app for psychologists — it organises clients, sessions, notes and finances in one clear, secure and professional space.",
            h1sr: "TheraOffice — The private practice management app for psychologists and mental health professionals",
            ctaPrimary: "Download on the App Store",
            downloadSmall: "Download on the",
            ctaSecondary: "Register your interest",
            trialLine: "14-day free trial · Then €14.99 / month",
            available: "Available now for iOS & Android",
            trial: "14-day free trial",
            scroll: "Scroll to explore",
        },
        marquee: [
            "AI Session Notes",
            "Story Mode",
            "Client Management",
            "Smart Scheduling",
            "Financials & Debts",
            "Surveys & Questionnaires",
            "Exercise Library",
            "GDPR Compliant",
        ],
        chapters: [
            {
                id: "features",
                num: "01",
                label: "Client management",
                title: "Every case, perfectly organised",
                body: "The Clients section centralises the essential information and progress of each client — without unnecessary complexity.",
                bullets: [
                    "Profiles with photo, full name, email, phone, address and emergency contact",
                    "Tags and colours for easy organisation and categorisation",
                    "Session history and notes gathered on each client's card",
                    "“Remember before session”: the AI reads previous notes and reminds you where you left off",
                    "Therapeutic Journey: sessions, notes and key events on one chronological timeline, exportable as PDF",
                ],
                imgs: ["/screenshots/clients-list.webp", "/screenshots/IMG_4762.jpg", "/screenshots/IMG_4761.jpg"],
                alt: "Client list with search and tags in TheraOffice",
            },
            {
                id: "sessions",
                num: "02",
                label: "Sessions & calendar",
                title: "Your schedule, at a glance",
                body: "Create, complete and track every session — in person or online — from a calendar designed for the rhythm of your practice.",
                bullets: [
                    "Day, week and month calendar views",
                    "Online sessions with a meeting link",
                    "Completion with status: completed, no-show, cancelled or rescheduled",
                    "Payment: paid, unpaid, free or partial with an amount field",
                    "Client reminders via a pre-filled email — with an indicator once sent",
                ],
                imgs: ["/screenshots/IMG_4766.jpg", "/screenshots/IMG_4737.jpg", "/screenshots/IMG_4741.jpg", "/screenshots/IMG_4745.jpg"],
                alt: "August 2026 calendar with day, week and month views",
            },
            {
                id: "ai",
                num: "03",
                label: "Artificial intelligence",
                title: "An assistant that reads your notes",
                body: "TheraOffice's AI organises, summarises and narrates — always based on your own recorded data, never inventing anything.",
                bullets: [
                    "Improve, summarise and rephrase notes — with the option to revert to the original",
                    "Story Mode: clinical narration, quick recap or a safe narration suitable for your client",
                    "Mood Graph: a mood chart built from your observations, each point linked to its note",
                    "The AI generates only from events and notes you have recorded — it never invents",
                    "It supports organisation and summarising — it never replaces your clinical judgement",
                ],
                imgs: ["/screenshots/IMG_4765.jpg", "/screenshots/IMG_4757.jpg", "/screenshots/IMG_4764.jpg"],
                alt: "Story Mode — AI narration of the therapeutic journey",
            },
            {
                id: "financials",
                num: "04",
                label: "Financials",
                title: "Income and debts, without spreadsheets",
                body: "A complete picture of your practice's financial activity, updated automatically with every session.",
                bullets: [
                    "Income by day, week, month, year and in total — with average session fee",
                    "Outstanding debts and unpaid sessions, broken down per client",
                    "Payment methods: card, cash, bank transfer",
                    "Income graphs for the last 7 days and 6 months, with history by month",
                    "Cancellation and no-show rates, and total session count",
                ],
                imgs: ["/screenshots/IMG_4782.jpeg", "/screenshots/IMG_4783.jpeg"],
                alt: "Financial overview with income, debts and payment methods",
            },
            {
                id: "library",
                num: "05",
                label: "Library & surveys",
                title: "Tools ready for the session — and after it",
                body: "Ready-made therapeutic exercises and questionnaires with results analysis, all inside the app.",
                bullets: [
                    "Ready exercises: Thought Record, 4-7-8 Breathing, Behavioral Activation, Progressive Muscle Relaxation",
                    "Filters by approach and problem (CBT, anxiety, depression, relaxation) — plus your own exercises with tags",
                    "Questionnaires with multiple choice, Likert scales, ratings, yes/no, short text and numbers",
                    "Publish with a unique participation link and watch results in real time",
                    "AI results analysis: summary, key findings, suggestions and limitations",
                ],
                imgs: ["/screenshots/IMG_4774.jpeg", "/screenshots/IMG_4775.jpeg", "/screenshots/IMG_4787.jpeg"],
                alt: "Exercise library with CBT, anxiety and relaxation filters",
            },
        ],
        bento: {
            overline: "And a little more",
            title: "Everything you need, in one place",
            more: "Learn more",
            items: [
                {
                    title: "Therapist's cabinet",
                    body: "Files, notes, links and photos in a personal storage space.",
                    img: "/screenshots/IMG_4772.jpeg",
                    details: [
                        "New folder, new note or new link with a single tap",
                        "Photos from camera or gallery, and files (PDF, doc…)",
                        "All your everyday materials in one central place",
                    ],
                },
                {
                    title: "QR professional card",
                    body: "Your professional card, showing only the details you choose.",
                    img: "/screenshots/IMG_4777.jpeg",
                    details: [
                        "Generated automatically from your therapist profile",
                        "You choose what appears: photo, phone, email, address, education, experience, social media",
                        "Alternatively, upload your own card as a PDF or photo",
                        "Anyone who scans the QR sees only what you have selected",
                    ],
                },
                {
                    title: "Reminders",
                    body: "Update your client about their session with a single tap.",
                    img: "/screenshots/IMG_4797.jpeg",
                    details: [
                        "From the session card, with a single tap",
                        "Choose your email app (Gmail, Outlook, Yahoo)",
                        "A pre-filled message with the date, time and mode of the session",
                        "An indicator appears next to the session once it's sent",
                    ],
                },
                {
                    title: "PDF exports",
                    body: "Notes, therapeutic journey and results — printable and shareable.",
                    img: "/screenshots/IMG_4780.jpeg",
                    details: [
                        "Notes, therapeutic journey, exercises and survey results",
                        "Selective export: you decide exactly what each file includes",
                        "Your profile details are included automatically",
                        "Print or share directly from the app",
                    ],
                },
                {
                    title: "Mood Graph",
                    body: "Your client's emotional journey on an interactive graph.",
                    img: null,
                    details: [
                        "The AI identifies mood indicators from your notes",
                        "A visual of the emotional journey, session to session",
                        "Every point on the graph links to the related note excerpt",
                        "Exportable as PDF for archiving or printing",
                    ],
                },
                {
                    title: "Security & GDPR",
                    body: "Designed with a focus on protecting personal and professional data.",
                    img: null,
                    details: [
                        "GDPR compliant, protecting sensitive materials (photos, documents)",
                        "No data is used for advertising tracking",
                        "Subscriptions are handled exclusively via the App Store / Google Play — TheraOffice stores no payment details",
                        "Permanently delete your account and data whenever you wish",
                    ],
                },
            ],
        },
        features: {
            overview: {
                overline: "Features",
                title: "Everything your practice needs. In one place.",
                text: "TheraOffice brings the daily organisation of your private practice into one clean and easy-to-use environment.",
                benefits: [
                    "Client and session organisation",
                    "Notes and history",
                    "Financial tracking",
                    "Therapeutic exercises",
                    "Surveys & questionnaires",
                    "Smart AI features",
                ],
                cta: "Explore all features",
                cards: [
                    { title: "Clients", desc: "Profile and history management" },
                    { title: "Sessions & Calendar", desc: "Organisation and reminders" },
                    { title: "Notes", desc: "Secure and organised" },
                    { title: "Finances", desc: "Payments, receipts, reports" },
                    { title: "Questionnaires", desc: "Creation and assessment" },
                    { title: "Library", desc: "Useful material and resources" },
                    { title: "Digital Card", desc: "Showcase your professional profile" },
                    { title: "AI Features", desc: "Smart support for your daily work" },
                ],
            },
            aiStrip: {
                overline: "Technology that supports you",
                title: "AI features for greater ease",
                text: "TheraOffice uses artificial intelligence to save you time and help you provide even higher quality care.",
                link: "Learn more",
                items: [
                    { title: "Notes summary", desc: "Quick recap and key points" },
                    { title: "Questionnaire delivery", desc: "Automatic sending to clients" },
                    { title: "Results analysis", desc: "Smart interpretation and suggestions" },
                    { title: "Progress recap", desc: "A concise view of the journey" },
                    { title: "Mood graph", desc: "Visualising emotions over time" },
                    { title: "Therapeutic journey", desc: "Tracking goals and milestones" },
                ],
            },
            howItWorks: "How it works",
            catsLabel: "Note categories",
            noteCategories: [
                { name: "Presenting problem", desc: "What is on the client's mind right now — the issue they bring to the session." },
                { name: "Request", desc: "The goal or request with which the therapeutic process began." },
                { name: "Progress", desc: "Steps forward, changes and anything showing movement in therapy." },
                { name: "Intervention", desc: "Techniques and interventions applied during the session." },
                { name: "Phenomenological observation", desc: "Immediate, experiential observations as they emerged in the session." },
                { name: "Observation", desc: "General observations you want to keep for the case." },
                { name: "Next session plan", desc: "What you will work on next time — your thinking and planning." },
                { name: "History", desc: "Biographical and historical information about the client." },
                { name: "Trauma", desc: "Notes related to traumatic experiences, handled with particular care." },
                { name: "Other", desc: "Anything that doesn't fit a category — or your own section with “+ Section”." },
            ],
            list: [
                {
                    num: "01",
                    title: "Home Screen",
                    short: "The home screen acts as the central organisation point of your practice and offers immediate access to the app's core functions.",
                    details: [
                        "Quick actions: instantly create a new note, client or session",
                        "Public professional card: present your details via QR",
                        "Financials: payments, debts and a basic financial overview",
                        "Surveys: access to questionnaires and results",
                        "Today's sessions: your day's schedule at a glance",
                        "Summary activity: daily and weekly sessions",
                        "Central navigation: clients, calendar, cabinet and library",
                    ],
                    imgs: ["/guide/48.webp"],
                    alt: "TheraOffice home screen with quick actions, finances and today's sessions",
                },
                {
                    num: "02",
                    title: "Client Management",
                    short: "Organise the essential details, tags, notes and progress of each client.",
                    details: [
                        "Go to the Clients section and select New Client",
                        "Fill in the basics: full name, email, phone, address, emergency contact, preferred language",
                        "Add tags (e.g. “Anxiety”) with “+ New tag” and a colour for easier categorisation",
                        "Optionally choose a profile photo",
                        "Tap Save — the new profile is created with organised information, notes and session history",
                    ],
                    imgs: ["/guide/47.webp", "/guide/46.webp"],
                    alt: "Adding a new client with details and tags",
                },
                {
                    num: "03",
                    title: "Adding a Session",
                    short: "Easily schedule a new session and add it to your calendar.",
                    details: [
                        "Tap New Session from the home screen or inside the Calendar",
                        "Select the client from the dropdown list and the session title",
                        "Set the date and time — using the provided presets or typing your own",
                        "Choose the duration: 30, 45, 50, 60 minutes or a custom one",
                        "For online sessions, enable the option and add the meeting link — for in-person, select accordingly",
                        "Optionally add session tags for easier organisation",
                        "Tap Save and the session is added to your schedule",
                    ],
                    imgs: ["/guide/45.webp", "/guide/44.webp"],
                    alt: "Creating a new session with date, time and duration",
                },
                {
                    num: "04",
                    title: "Your Session in Real Time",
                    short: "See your next appointment and follow the session as it unfolds.",
                    details: [
                        "The upcoming session appears on the home screen with its start time and a countdown",
                        "Before the session, the “Remember before session” option helps you prepare",
                        "Once it starts, the session card switches to “In progress”",
                        "A timer shows the elapsed and the remaining time",
                        "Tap Note to record anything you need directly during the session",
                    ],
                    imgs: ["/guide/43.webp", "/guide/41.webp"],
                    alt: "Upcoming session card with countdown and in-progress state",
                },
                {
                    num: "05",
                    title: "Session Completion",
                    short: "Record what happened in the session and update its status.",
                    details: [
                        "Open the session and select Complete Session",
                        "Status: completed, client did not attend, cancelled or rescheduled with a new date and time",
                        "Session type: in person or online",
                        "Payment: paid, unpaid, free or partial — partial opens a field for the amount paid",
                        "Enter the paid and expected amounts (€) and add notes",
                        "Jump straight to Notes, the client card or the reminder option — then Save",
                    ],
                    imgs: ["/guide/40.webp", "/guide/39.webp"],
                    alt: "Session completion screen with status, payment and notes",
                },
                {
                    num: "06",
                    title: "Sending a Reminder",
                    short: "Easily send an update to your client before the session.",
                    details: [
                        "Open the session card and select Reminder",
                        "Choose your preferred email app: Gmail, Outlook, Yahoo Mail or the default one",
                        "A ready-made email opens automatically with your therapist details",
                        "The message already includes the session date, time and mode of delivery",
                        "All you need to do is press Send",
                        "A small icon appears next to the session in the Calendar once the reminder has been sent",
                    ],
                    imgs: ["/guide/4.webp", "/guide/2.webp", "/guide/1.webp", "/guide/3.webp"],
                    alt: "Sending a session reminder via a pre-filled email",
                },
                {
                    num: "07",
                    title: "Financials",
                    short: "See your practice's financial picture at a glance.",
                    details: [
                        "Income for the day, week, month and in total",
                        "Total outstanding debts, broken down per client and session with a remaining balance",
                        "Unpaid sessions and pending payments",
                        "Payment methods: card, cash, bank transfer",
                        "Total sessions and cancellation / no-show rates",
                        "Income graphs: last 7 days, last 6 months and history by month",
                    ],
                    imgs: ["/guide/17.webp", "/guide/18.webp", "/guide/16.webp"],
                    alt: "Financial overview with income, debts and graphs",
                },
                {
                    num: "08",
                    title: "Organised Notes",
                    short: "Record and organise information for each client with clear categorisation.",
                    details: [
                        "New note from the Home screen or from inside the client card",
                        "Select the client — the session date is pre-set and can be changed with the arrows",
                        "Categorise with sections: Presenting problem, Request, Progress, Intervention, Observation, History, Next session plan, Other",
                        "Create your own categories with “+ Section”",
                        "Add text, photos, images or a voice recording and tap Save",
                    ],
                    imgs: ["/guide/37.webp"],
                    alt: "Creating a note with content categories",
                },
                {
                    num: "09",
                    title: "AI Assistance in Notes",
                    short: "Use AI to organise your text better.",
                    details: [
                        "Notes support text, photos, images or voice recording",
                        "After writing, select AI Assistance below the text field",
                        "Improve: clearer and more organised phrasing",
                        "Summarise: the key points of a longer note",
                        "Rephrase: the same content in a different, more structured way",
                        "You can view or revert to the original text at any time",
                        "Notes can be exported as PDF or printed",
                    ],
                    imgs: ["/guide/36.webp", "/guide/34.webp"],
                    alt: "AI assistance in a note with improve and summarise actions",
                },
                {
                    num: "10",
                    title: "Remember Before Session",
                    short: "A brief AI reminder of what matters before your next session.",
                    details: [
                        "Available from the next-session card on the home screen",
                        "And from the client card, under Overview or Therapeutic Journey",
                        "The AI reads previous notes and identifies the most important points of the process",
                        "It creates a brief reminder with key themes and recent developments",
                        "Includes “AI – Key points” and therapy “Milestones” — you remember where you left off",
                    ],
                    imgs: ["/guide/33.webp", "/guide/8.webp", "/guide/6.webp"],
                    alt: "AI reminder before the session with key points",
                },
                {
                    num: "11",
                    title: "Therapeutic Journey",
                    short: "See each client's progress on an organised chronological timeline.",
                    details: [
                        "The AI reads notes and helps identify significant events in the journey",
                        "You choose which events to keep, so the timeline stays organised",
                        "Includes sessions, notes, therapeutic work and important events, sorted chronologically",
                        "Categorise with tags (e.g. #work, #boundaries, #fear of rejection)",
                        "The Therapeutic Journey can be exported as PDF or printed",
                    ],
                    imgs: ["/guide/33.webp", "/guide/32.webp"],
                    alt: "Chronological timeline of a client's therapeutic journey",
                },
                {
                    num: "12",
                    title: "Story Mode",
                    short: "Turn the client's journey into a natural, continuous narrative.",
                    details: [
                        "Clinical Narration: a more detailed, professional presentation",
                        "Quick Recap: a brief capture of the key points",
                        "Safe Narration: carefully worded text suitable for presenting to the client",
                        "The AI organises already-recorded events and notes chronologically into a more readable narrative",
                        "You can save the generated narration",
                    ],
                    imgs: ["/guide/31.webp", "/guide/30.webp"],
                    alt: "Story Mode with three narration styles for the therapeutic journey",
                },
                {
                    num: "13",
                    title: "Mood Graph",
                    short: "Visually track the client's emotional journey over time.",
                    details: [
                        "From the client card, select Mood Graph",
                        "The AI detects key mood indicators from notes and plots them on a graph",
                        "Each point corresponds to a recorded observation — tap it to see the note excerpt",
                        "At the bottom you'll find a summary of the journey and a legend of indicators (coping, anxious, distressed)",
                        "The graph can be exported as PDF for saving or printing",
                    ],
                    imgs: ["/guide/50.webp"],
                    alt: "Client mood graph over time",
                },
                {
                    num: "14",
                    title: "Therapist's Cabinet",
                    short: "A personal storage space for professional material inside the app.",
                    details: [
                        "Organise files, documents, photos, links and notes in one place",
                        "Tap “+” for a new folder, new note or new link",
                        "A photo straight from your camera or an image from your gallery",
                        "Files of any type (PDF, doc…)",
                        "All the materials of your daily practice, always available",
                    ],
                    imgs: ["/guide/28.webp", "/guide/29.webp"],
                    alt: "Therapist's cabinet with folders and options to add material",
                },
                {
                    num: "15",
                    title: "Therapeutic Exercise Library",
                    short: "Use ready-made exercises or create and organise your own.",
                    details: [
                        "Ready-made therapeutic exercises for immediate use",
                        "Add your own with “+”: title, description, technique, duration, difficulty level",
                        "Organise and categorise with tags — by type, therapeutic approach or problem",
                        "Search and filters: All, CBT, Anxiety, Depression, Relaxation",
                        "Every exercise can be printed or sent to the client",
                    ],
                    imgs: ["/guide/27.webp"],
                    alt: "Exercise library with filters and search",
                },
                {
                    num: "16",
                    title: "Therapist Profile",
                    short: "Organise the professional details you want to display through TheraOffice.",
                    details: [
                        "Go to Settings and select Therapist Profile",
                        "Profile photo, logo, full name, professional title and licence to practise",
                        "Years of experience, degrees, certifications, specialisations and languages",
                        "Contact details and addresses",
                        "You choose which of these are displayed",
                        "They appear automatically in files you export or print, and on your digital professional card",
                    ],
                    imgs: ["/guide/23.webp", "/guide/25.webp"],
                    alt: "Therapist profile form with degrees and details",
                },
                {
                    num: "17",
                    title: "QR Professional Card",
                    short: "Create and share your professional card easily via QR.",
                    details: [
                        "The QR card is generated automatically from your Therapist Profile",
                        "Accessible from the home screen via “Public professional card”",
                        "Alternatively, upload your own business card as a PDF or photo",
                        "Choose which card is displayed and which fields it includes (photo, phone, email, education, experience, social media)",
                        "Copy the link or share the QR with anyone",
                    ],
                    imgs: ["/guide/21.webp", "/guide/22.webp", "/guide/19.webp", "/guide/20.webp"],
                    alt: "Digital professional card with QR code",
                },
                {
                    num: "18",
                    title: "Surveys & Questionnaires",
                    short: "Create and manage surveys directly inside the app.",
                    details: [
                        "New survey with title, description, purpose and contact details",
                        "Consent text and data retention period",
                        "Question types: multiple choice, dropdown, Likert scale, numerical rating, Yes/No, short text, open-ended answer, number",
                        "Anonymous, pseudonymous or named participation — multiple submissions, maximum responses, opening and closing dates",
                        "Publishing generates a unique link you send to participants",
                    ],
                    imgs: ["/guide/15.webp", "/guide/14.webp", "/guide/13.webp"],
                    alt: "Creating a survey with question types and participation settings",
                },
                {
                    num: "19",
                    title: "Live Results & AI Analysis",
                    short: "Watch responses as they arrive and see automatic statistics and AI insights.",
                    details: [
                        "Every new response appears immediately, live on your phone",
                        "Automatic graphs, percentages and statistics for each question",
                        "The AI Analysis uses the already-calculated statistics",
                        "It produces a summary, key findings, suggestions and limitations (e.g. due to small sample size)",
                        "Export the results as PDF",
                    ],
                    imgs: ["/guide/9.webp", "/guide/10.webp", "/guide/11.webp", "/guide/12.webp"],
                    alt: "Live survey results with graphs and AI analysis",
                },
                {
                    num: "20",
                    title: "Settings & Help",
                    short: "Access additional management and support tools.",
                    details: [
                        "Selective export: you choose exactly which details appear in the file you export or print",
                        "Help & Guides on using the app",
                        "AI Support for questions about TheraOffice features",
                        "Comments & Suggestions: send feedback and ideas to improve the app",
                        "GDPR compliant, no advertising tracking, with permanent account deletion available",
                    ],
                    imgs: ["/guide/7.webp"],
                    alt: "App settings with help and selective export",
                },
            ],
        },
        pricing: {
            overline: "Pricing & Subscriptions",
            title: "14-day free trial",
            bandOverline: "Start today",
            bandText: "Discover how TheraOffice can make a difference in your everyday practice.",
            checks: ["Full access to every feature", "No commitment", "Cancel anytime"],
            thenLabel: "Then",
            cta: "Start Free",
            price: "€14.99",
            perMonth: "per month",
            trialBadge: "14-day free trial",
            cardNote: "No tiers and no hidden fees — access to every TheraOffice feature.",
            points: [
                "For now, TheraOffice offers a single, simple subscription plan — no different tiers or complicated options.",
                "Your subscription starts with a 14-day free trial, so you can get to know the app and try its features in practice before deciding whether to continue. During the trial you can use TheraOffice for organising clients, sessions, notes, finances, therapeutic exercises, surveys and the app's smart features.",
                "After the 14 days end, the subscription costs €14.99 per month.",
                "If during the free trial you decide you don't want to continue, you can cancel your subscription at any time before the 14 days are over, with no charge for the following month. Managing and cancelling your subscription is done through your App Store or Google Play account, depending on your device.",
                "Payments are handled exclusively through Apple's and Google's official, secure payment systems. TheraOffice does not store, process or have access to your credit or debit card details.",
                "The subscription renews automatically each month, unless you cancel it from your Apple or Google settings before the next renewal date.",
                "Our pricing philosophy is to stay as simple and clear as possible: one subscription, one price and access to TheraOffice's features — without having to choose between different packages.",
            ],
        },
        support: {
            overline: "Support",
            title: "How can we help?",
            sub: "Facing a problem with the app, or want to delete your account? Choose the form that applies to you.",
            problem: {
                title: "Report a problem",
                desc: "Describe your problem or question and our team will get back to you as soon as possible.",
                subject: "Subject",
                subjects: ["Technical issue", "Account & subscription", "Improvement suggestion", "Something else"],
                message: "Problem description",
                submit: "Send request",
                success: "Support request sent — we'll be in touch soon.",
            },
            deletion: {
                title: "Delete TheraOffice Account",
                intro: "Submitting this request will delete your TheraOffice account and associated personal data, except data we may need to retain where legally required. Our team reviews every request personally and will confirm completion by email.",
                name: "Full name",
                email: "Account email",
                reason: "Reason (optional)",
                confirm: "I understand that this request is for the deletion of my TheraOffice account.",
                submit: "Submit Deletion Request",
                success: "Deletion request submitted — you'll receive an email confirmation once completed.",
            },
        },
        showcase: {
            metaTitle: "TheraOffice Features | Practice Management for Psychologists",
            metaDesc: "Explore TheraOffice features in detail: client management, sessions, notes, finances, therapeutic exercises, surveys and AI tools.",
            overline: "Interactive guide",
            title: "App Presentation / Features",
            subtitle: "Discover in detail how TheraOffice organises the daily operation of a mental health professional — from sessions and notes to the client's journey, finances, exercises, surveys and AI tools.",
            discoveryTitle: "What do you want to organise better?",
            allLabel: "All",
            resultsLabel: "Results",
            topics: [
                { id: "sessions", label: "Sessions", nums: ["03", "04", "05", "06"] },
                { id: "clients", label: "Clients", nums: ["02", "08", "11", "12", "13"] },
                { id: "notes", label: "Notes", nums: ["08", "09", "10"] },
                { id: "finance", label: "Finances", nums: ["07"] },
                { id: "exercises", label: "Therapeutic Exercises", nums: ["15"] },
                { id: "surveys", label: "Surveys", nums: ["18", "19"] },
                { id: "ai", label: "AI", nums: ["09", "10", "11", "12", "13", "19"] },
            ],
            categories: [
                { id: "org", label: "Organisation", title: "Everyday Organisation", nums: ["01", "03", "04", "05", "06", "07"] },
                { id: "clients", label: "Clients", title: "Clients & Clinical Journey", nums: ["02", "08", "10", "11", "12", "13"] },
                { id: "ai", label: "AI", title: "AI Tools", nums: ["09", "10", "11", "12", "13", "19"] },
                { id: "tools", label: "Tools", title: "Therapist Tools", nums: ["14", "15"] },
                { id: "profile", label: "Professional Profile", title: "Professional Presence", nums: ["16", "17"] },
                { id: "surveys", label: "Surveys", title: "Surveys & Assessment", nums: ["18", "19"] },
                { id: "settings", label: "Settings", title: "Settings & Support", nums: ["20"] },
            ],
            ctaTitle: "See how TheraOffice can organise your own everyday practice.",
            ctaText: "Try every feature and see which ones fit the needs of your practice best.",
            ctaPrimary: "14-day free trial",
            ctaSecondary: "Contact",
        },
        news: {
            metaTitle: "News & Articles | TheraOffice",
            metaDesc: "News, articles and updates from TheraOffice — the practice management app for psychologists.",
            overline: "Blog / Updates",
            title: "News",
            subtitle: "News, articles and updates from TheraOffice.",
            filters: { all: "All", article: "Articles", news: "TheraOffice News", instagram: "Social", guide: "Guides" },
            readMore: "Read more",
            viewInstagram: "View the post on Instagram",
            viewOriginal: "View the post on",
            share: "Share",
            copyLink: "Copy link",
            copied: "Link copied",
            related: "Related articles",
            back: "All news",
            latestTitle: "Latest News",
            latestCta: "View all news",
            empty: "There are no posts in this category yet.",
            loading: "Loading…",
        },
        availability: {
            overline: "Download the app",
            title: "Download TheraOffice",
            sub: "Available now for iOS and Android. Start with a 14-day free trial — no commitment, cancel anytime.",
            ios: "Download on the App Store",
            androidBadge: "Get it on Google Play",
            note: "Subscriptions are handled securely via the App Store or Google Play · No payment details are stored",
            guide: "Download the user guide (PDF)",
        },
        founder: {
            overline: "About us",
            title: "From the practice, for the practice",
            quote: "I wanted a tool truly tailored to the way we work — less time on administration, more time on the therapeutic process.",
            name: "Angelos Daldogiannis",
            posterAlt: "Angelos Daldogiannis, psychologist and creator of TheraOffice — Made by a psychologist, for psychologists",
            role: "Psychologist · Creator of TheraOffice",
            body: "A graduate of the Department of Psychology at the University of Western Macedonia, with continuing training in the Gestalt approach. The idea for TheraOffice was born from everyday experience in the field of psychology — and it keeps evolving alongside the real needs of the professionals who use it.",
        },
        contact: {
            overline: "Contact",
            title: "Let's talk about your practice",
            sub: "Register your interest, request a demo, or ask us anything about your practice.",
            name: "Full name",
            email: "Email",
            role: "Profession (e.g. Psychologist)",
            message: "Message",
            submit: "Send message",
            sending: "Sending…",
            success: "Message sent — we'll be in touch soon.",
            error: "Something went wrong. Try again or write to us at theraofficeeu@gmail.com.",
            direct: "Or reach out directly",
            support: "Support centre",
        },
        footer: {
            tagline: "More care. Less management.",
            made: "Made by psychologists, for psychologists.",
            rights: "© 2026 TheraOffice. With appreciation from our team.",
            links: { appstore: "App Store", googleplay: "Google Play", support: "Support", instagram: "Instagram", facebook: "Facebook", email: "Email", privacy: "Privacy Policy", terms: "Terms & Conditions" },
        },
    },
};
